import { CatalogAttachment } from '../../catalog/catalogAttachments';

export type AssetType = 'Pet' | 'Vehicle' | 'Property' | 'Other';

export const ALL_ASSET_TYPES: AssetType[] = ['Pet', 'Vehicle', 'Property', 'Other'];

export interface AssetOwner {
  contactPersonId: string;
  isRegistered: boolean;
  isPrimary: boolean;
}

export interface Asset {
  id: string;
  name: string;
  assetType: AssetType;
  contactPersonIds: string[];
  owners: AssetOwner[];
  identifier?: string;
  details: Record<string, unknown>;
  createdAt?: string;
  updatedAt?: string;
  attachments: CatalogAttachment[];
}

export interface AssetSettings {
  id: string;
  availableTypes: AssetType[];
  enabledTypes: AssetType[];
  createdAt?: string;
  updatedAt?: string;
}

export const assetTypeLabelKey = (type: string): string =>
  `assetTypes.${type.charAt(0).toLowerCase()}${type.slice(1)}`;

export const normalizeAssetType = (value: unknown): AssetType => {
  if (typeof value === 'number' && Number.isInteger(value) && value >= 0 && value < ALL_ASSET_TYPES.length) {
    return ALL_ASSET_TYPES[value];
  }

  const raw = String(value ?? '').trim();
  if (!raw) {
    return 'Other';
  }

  const lower = raw.toLowerCase();
  if (lower === 'car') {
    return 'Vehicle';
  }
  if (lower === 'house' || lower === 'houses' || lower === 'property') {
    return 'Property';
  }
  if (lower === 'insuredasset') {
    return 'Other';
  }

  return ALL_ASSET_TYPES.find(type => type.toLowerCase() === lower) ?? 'Other';
};

export const getPrimaryOwnerId = (asset: Pick<Asset, 'owners' | 'contactPersonIds'>): string | undefined =>
  asset.owners.find(owner => owner.isPrimary)?.contactPersonId || asset.contactPersonIds[0];

export default Asset;
